import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {queries} from '@/shared/integrations/zero'
import {ListTradeNamesInput} from '@cypro/engine/queries'
import {TradeName} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useMemo, useState} from 'react'

export function useGetTradeNames({
  sort = {dir: 'asc', field: 'name'},
  filters,
  limit,
}: Omit<Partial<ListTradeNamesInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<TradeName>>(createTopAnchor<TradeName>())

  const cursor =
    anchor.startRow?.id && anchor.startRow?.createdAt
      ? {
          id: anchor.startRow.id,
          direction: anchor.direction,
          createdAt: anchor.startRow.createdAt,
          name: anchor.startRow.name,
        }
      : undefined

  const query = queries.products.listTradeNames({
    cursor,
    sort,
    filters: {status: ['active'] as const, ...filters},
    limit,
  })
  const [tradeNames, meta] = useQuery(query)

  const filtersHash = useMemo(() => JSON.stringify(filters), [filters])
  useEffect(() => {
    setAnchor(createTopAnchor<TradeName>())
  }, [sort?.dir, sort?.field, filtersHash, limit])

  return {
    query,
    meta,
    tradeNames,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: tradeNames.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
